var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLeftNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54636 11L13.4815 7.06485C13.8395 6.70687 13.8395 6.12647 13.4815 5.76849C13.1235 5.4105 12.5431 5.4105 12.1852 5.76849L7.60182 10.3518C7.24384 10.7098 7.24384 11.2902 7.60182 11.6482L12.1852 16.2315C12.5431 16.5895 13.1235 16.5895 13.4815 16.2315C13.8395 15.8735 13.8395 15.2931 13.4815 14.9352L9.54636 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLeftNav);
export default __webpack_public_path__ + "static/media/whiteLeftNav.30e28d2089fafa863e5f1248ff9d9c57.svg";
export { ForwardRef as ReactComponent };